<template><section><h3>插件介绍</h3>
<p>Axis， 坐标轴。</p>
<h4>attr 属性：</h4>
<table>
<thead>
<tr>
<th>名称</th>
<th>说明</th>
<th>类型</th>
<th>可选值</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>orient</td>
<td>坐标轴的方向</td>
<td></td>
<td>['top','right','bottom','left']</td>
<td>'bottom'</td>
</tr>
<tr>
<td>name</td>
<td>坐标轴名称</td>
<td></td>
<td></td>
<td></td>
</tr>
<tr>
<td>splitNumber</td>
<td>Number</td>
<td>0</td>
<td>坐标轴的分割段数，同时须设置 visual 的 splitNumber 属性</td>
<td></td>
</tr>
<tr>
<td>formatter</td>
<td>Function</td>
<td><code v-pre>d =&gt; d</code></td>
<td>文本格式化函数</td>
<td></td>
</tr>
</tbody>
</table>
<h4>style 样式：</h4>
<pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> axis = <span class="hljs-keyword">new</span> Axis({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'left'</span> })
axis.style(<span class="hljs-string">'scale'</span>, <span class="hljs-literal">false</span>)
</code></pre>
<table>
<thead>
<tr>
<th>名称</th>
<th>基本类型</th>
<th>说明</th>
</tr>
</thead>
<tbody>
<tr>
<td>axis</td>
<td>线</td>
<td>坐标轴样式</td>
</tr>
<tr>
<td>name</td>
<td>文本</td>
<td>坐标轴名字</td>
</tr>
<tr>
<td>scale</td>
<td>线</td>
<td>坐标轴上的刻度</td>
</tr>
<tr>
<td>label</td>
<td>文本</td>
<td>坐标轴上文本类型</td>
</tr>
</tbody>
</table>
</section></template><script>export default {components:{}}</script>